'use strict';

var ngSanitize = require('angular-sanitize');
var ngTranslate = require('angular-translate');
var ngAnimate = require('angular-animate');
var ngCookie = require('angular-cookies');
var ngResource = require('angular-resource');

var ngDroFramework = 'ngDro';
angular.module(ngDroFramework, ['ui.router', ngSanitize, ngTranslate, ngAnimate, ngCookie, 'ngStorage', ngResource]);

global.ngDroModules.push(ngDroFramework);

angular.module(ngDroFramework).service('MainViews', require('./services/MainViews'));
angular.module(ngDroFramework).service('StatesHandler', require('./services/StatesHandler'));

angular.module(ngDroFramework).config(require('./configs/LocationProvider'));

angular.module(ngDroFramework).config(require('./configs/StateProvider'));

angular.module(ngDroFramework).config(require('./configs/TranslateProvider'));

angular.module(ngDroFramework).run(['$rootScope', '$state', 'MainViews', function ($rootScope, $state, MainViews) {
  
    $rootScope.$state = $state;
    $rootScope.mainViews = MainViews.getViews();
    $rootScope.modules = global.ngDroModules;
   
}]);



//////////////////
// WEBPACK FOOTER
// ./src/gateway/core/index.js
// module id = 184
// module chunks = 2